import {HttpErrorResponse,HttpResponse} from '@angular/common/http';
import {AfterViewInit,Component,OnDestroy,OnInit} from '@angular/core';
import {ActivatedRoute,ParamMap} from '@angular/router';
import {IMyDateModel,IMyOptions} from 'mydatepicker';
import {JhiAlertService} from 'ng-jhipster';
import {BsModalRef,BsModalService} from 'ngx-bootstrap';
import {TreeviewConfig,TreeviewItem} from 'ngx-treeview';
import {Observable,forkJoin} from 'rxjs';
import {Principal} from 'src/app/core';
import {ClauseExtensionMySuffixService} from 'src/app/entities/clause-extension-my-suffix/clause-extension-my-suffix.service';
import {CountryMySuffixService} from 'src/app/entities/country-my-suffix';
import {ConfirmationModalComponent} from 'src/app/shared/confirmation-modal/confirmation-modal.component';
import {ConfirmationModelService} from 'src/app/shared/confirmation-modal/confirmation-model.service';
import {currenyMaskService} from 'src/app/shared/currencyMask.service';
import {InformationModelService} from 'src/app/shared/information-model/Information-model.service';
import {InformationModelComponent} from 'src/app/shared/information-model/information-model.component';
import {IAddressMySuffix,State} from 'src/app/shared/model/address-my-suffix.model';
import {ICountryMySuffix} from 'src/app/shared/model/country-my-suffix.model';
import {IFileDataMySuffix} from 'src/app/shared/model/file-data-my-suffix.model';
import {FutureDataType} from 'src/app/shared/model/future_data_type.model';
import {InformationType} from 'src/app/shared/model/information_type.model';
import {IInsuranceCompanyMySuffix,ISurveyAssociationPriority,InsuranceCompanySurveyAssociationPriority} from 'src/app/shared/model/insurance-company-my-suffix.model';
import {ISurveyAssociationMySuffix} from 'src/app/shared/model/survey-association-my-suffix.model';
import {LanguageChangeService} from 'src/app/shared/services/language-change.service';
import {FileDataMySuffix} from './../../shared/model/file-data-my-suffix.model';
import {InsuranceCompanyMySuffixService} from './insurance-company-my-suffix.service';

import * as cloneDeep from 'lodash/cloneDeep';


// import * as fs from 'fs';
declare var $: any;

@Component({
    selector: 'jhi-insurance-company-my-suffix-update',
    templateUrl: './insurance-company-my-suffix-update.component.html'
})
export class InsuranceCompanyMySuffixUpdateComponent implements OnInit, OnDestroy,AfterViewInit {
    private _insuranceCompany: IInsuranceCompanyMySuffix;
    isSaving: boolean;

    isInsurersCollapsed = true;

    signatures: IFileDataMySuffix[];

    companyaddresses: IAddressMySuffix[];

    numberPattern = '^(?=.*?[1-9])[0-9()-]+$';
    numberPatternCurrency = '^[0-9]+(.[0-9]{0,9})?$';

    numberStringPattern = '^[A-Za-z0-9]+$';

    telephoneCodeCountryObj = [];

    countriesObj = [];

    countries: ICountryMySuffix[];
    usCountryId: number;

    licensedCountries: ICountryMySuffix[] = [];

    excludeCountries: ICountryMySuffix[] = [];
    
    fileMultiPartData: any;
    flag = false;

    isfileUploaded = false;

    imageOnly = 'image/*';
    isValidFile: boolean;

    allowAdd: boolean;

    isStateMandatory: boolean = false;


    stateObj: any;

    stateData: State[] = [];
    allStates: State[] = [];

    licensedStates: State[] = [];

    excludeStates: State[] = [];
    isLicencedStateMandatory = false;
    isExcludedStateMandatory = false;
    standardSurveyDisabled: boolean = false;

    //itemsShowLimit: 5

    countryDropdownSettings = {
        singleSelection: false,
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        allowSearchFilter: true,
        idField: 'id',
        textField: 'name',
        itemsShowLimit: 5,
        defaultOpen:false
    };

    stateDropdownSettings = {
        singleSelection: true,
        allowSearchFilter: true,
        idField: 'id',
        textField: 'name',
        defaultOpen:false
    };

    addressCountryDropdownSettings = {
        singleSelection: true,
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        allowSearchFilter: true,
        idField: 'id',
        textField: 'name',
        closeDropDownOnSelection: true,
        defaultOpen:false
    };
    excludeCountriesDropdownSettings = {
        singleSelection: false,
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        allowSearchFilter: true,
        idField: 'id',
        textField: 'name',
        itemsShowLimit: 5,
        defaultOpen:false
    };




    surveyAssociationSettings = {
        singleSelection: true,
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        allowSearchFilter: true,
        idField: 'id',
        textField: 'name',
        closeDropDownOnSelection: true,
        defaultOpen:false
    };

    surveyAssociationPrioritySettings = {
        singleSelection: true,
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        allowSearchFilter: true,
        idField: 'id',
        textField: 'name',
        closeDropDownOnSelection: true,
        defaultOpen:false
    };

    surveyAssociationData: ISurveyAssociationMySuffix[];
    surveyAssociationOriginalData: ISurveyAssociationMySuffix[];

    surveyAssociationPriorities: ISurveyAssociationPriority[];
    surveyAssociationOriginalPriorities: ISurveyAssociationPriority[];

    surveyAssociationPriorityObj = [];
    surveyAssociationDataObj = [];


    // effective date
    date: Date = new Date();
    resetDateModel = { year: this.date.getFullYear(), month: this.date.getMonth() + 1, day: (this.date.getDate() - 1) }
    effectivepDatePickerOptions: IMyOptions = {
        dateFormat: 'dd/mm/yyyy',
        disableUntil: this.resetDateModel
    };
    fromEffeciveDate: any;
    dateModel = {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        day: new Date().getDate()
    }
    rateOptions: any;
    amountOptions: any;

    isChecked: boolean = false;
    continentsRegionCountries: any[] = [];
    nonAdmitCountriesId: any = [];
    excludeAdmitCountriesId: any = [];
    selectedLicensedForNonAdmitCountries: any = [];
    selectedExcludedAdmittedCountries: any = [];
    licensedForNonAdmitCountries:TreeviewItem[] = [];
    excludeAdmittedCountries:TreeviewItem[] = [];
    licensedForNonAdmitCountriesMap = new Map<number, any>();
    excludeAdmitCountriesMap=new Map<number,any>();
    
    allCountryTreeViewData=[];

    config = TreeviewConfig.create({
        hasAllCheckBox: true,
        hasFilter: true,
        hasCollapseExpand: true,
        decoupleChildFromParent: false,
        maxHeight: 400,
    });


    isInitDropdownMethodCalled=false;
    isInitDropdownMethodCalledExlcudedCountries=false;

    constructor(
        private jhiAlertService: JhiAlertService,
        private insuranceCompanyService: InsuranceCompanyMySuffixService,
        private countryService: CountryMySuffixService,
        private activatedRoute: ActivatedRoute,
        private clauseExtensionService: ClauseExtensionMySuffixService,
        private languageChangeService: LanguageChangeService,
        private principal: Principal,
        private modalService: BsModalService,
        private informationModelService: InformationModelService,
        private confirmationModelService: ConfirmationModelService,
        private currenyMask: currenyMaskService,

    ) {
        this.languageChangeService.refreshLanguage();
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
                window.history.back();
            }
    });
    }
    

    ngOnInit() {
        this.statesByCountryIsoTwo("US");
        this.fromEffeciveDate = { date: this.dateModel };
        this.effectivepDatePickerOptions.disableUntil = this.principal.dateFormateServerToClientMin(this.date);

        this.isValidFile = true;
        this.isSaving = false;

        this.rateOptions = this.currenyMask.ratePrecisionOptions;
        this.amountOptions = this.currenyMask.amountPrecisionOptions;

        this.insuranceCompanyService.checkStandardSurveyEnabled().subscribe(res => {
            this.standardSurveyDisabled = res.body.payload
        })

        this.activatedRoute.data.subscribe(({ insuranceCompany }) => {
            this.insuranceCompany = insuranceCompany;
            // console.warn(this.insuranceCompany.id != null);
            // console.log('INSURANCE : Comapany ::: ', this.insuranceCompany.fileDTO.name);
            let licensedNonAdmitCountries: any[] = [];
            let excludedCountries: any[] = [];
            // getting the licensed and excluded countries data from the API
            if(this.insuranceCompany && this.insuranceCompany.licensedNonAdmitCountries && this.insuranceCompany.licensedNonAdmitCountries.length > 0) {
                licensedNonAdmitCountries = this.insuranceCompany.licensedNonAdmitCountries;
            }
            // console.warn(this.insuranceCompany.licensedNonAdmitCountries.length);

            if(this.insuranceCompany && this.insuranceCompany.excludeCountries && this.insuranceCompany.excludeCountries.length > 0) {
                excludedCountries = this.insuranceCompany.excludeCountries;
            }
            // console.warn(insuranceCompany.excludeCountries);

            // getting the licensed and excluded countries checked data url based on the countries id
            let urlLicensedNonAdmitted = this.insuranceCompany.id != null ? this.countryService.getCheckedCountriesByContinents(licensedNonAdmitCountries.map(c => c.id)) : this.countryService.getCountriesWithContinents();

            let urlExcludedAdmitted = this.insuranceCompany.id != null ? this.countryService.getCheckedCountriesByContinents(excludedCountries.map(c => c.id)) : this.countryService.getCountriesWithContinents();

            // getting all the countries
            let allCountry=this.countryService.getCountriesWithContinents();

            forkJoin([urlLicensedNonAdmitted, urlExcludedAdmitted,allCountry]).subscribe((res: any) => {
                // console.warn(res);
                let lincencedData=res[0].body!=null ? res[0].body :res[0];
                let excludedData=res[1].body!=null ? res[1].body : res[1];
                // getting the data and converting it into TreeviewItem
                this.licensedForNonAdmitCountries = this.mapToTreeViewItem(lincencedData, 'licensedNonAdmitCountries');
                this.excludeAdmittedCountries = this.mapToTreeViewItem(excludedData, 'excludedCountries');
                // console.warn(this.licensedForNonAdmitCountries);
                // console.warn(this.excludeAdmittedCountries);

                // getting the default data and converting it into TreeviewItem
                this.allCountryTreeViewData=this.mapToTreeViewItem(res[ 2 ].body!=null? res[ 2 ].body:res[ 2 ],'');


                console.warn(this.insuranceCompany);
                if(this.insuranceCompany.id){
                    // console.warn(this.insuranceCompany.licensedNonAdmitCountries);
                    // console.warn(this.insuranceCompany.excludeCountries);
                    let exldId = this.insuranceCompany.excludeCountries.map(c=>c.id);
                    let lcdId = this.insuranceCompany.licensedNonAdmitCountries.map(c=>c.id);
                    // console.warn(lcdId, ' lcdId');
                    // console.warn(exldId, ' exldId');
                    this.excludeAdmittedCountries=this.getPreOrPostCountry(lcdId,this.allCountryTreeViewData);
    
                    if(exldId.length>0){
                        this.excludeAdmittedCountries=this.preserveCheckForCountries(exldId,this.excludeAdmittedCountries);
                        // console.warn(this.excludeAdmittedCountries);
                    }
                    
                    // console.warn(exldId, ' exldId');
                    this.licensedForNonAdmitCountries=this.getPreOrPostCountry(exldId,this.allCountryTreeViewData);
                    // console.warn(this.licensedForNonAdmitCountries);
    
                    // console.warn(lcdId, ' lcdId');
                    if(lcdId.length>0){
                        this.licensedForNonAdmitCountries=this.preserveCheckForCountries(lcdId,this.licensedForNonAdmitCountries);
                        // console.warn(this.licensedForNonAdmitCountries);
                    }

                    // console.warn(exldId);
                    // console.warn(lcdId);
                    this.selectedExcludedAdmittedCountries = exldId;
                    this.selectedLicensedForNonAdmitCountries = lcdId;

                }

                /**
                 * check, if excludeAdmittedCountries is empty, then set default allCountrydata.
                 * getPreOrPostCountry - 
                 * @param - all countries ids, all countries data
                 * after that, getPreOrPostCountry method will return checked and unchecked data
                 */
                // if(this.insuranceCompany.id) {
                //     this.excludeAdmittedCountries=this.excludeAdmittedCountries.length==0? this.allCountryTreeViewData:this.excludeAdmittedCountries;
                //     this.excludeAdmittedCountries=this.getPreOrPostCountry(lincencedData.map(c=>c.value),cloneDeep(this.excludeAdmittedCountries));
                // }

                // if(this.insuranceCompany.id) {
                //     this.licensedForNonAdmitCountries=this.licensedForNonAdmitCountries.length==0? this.allCountryTreeViewData:this.licensedForNonAdmitCountries;
                //     this.licensedForNonAdmitCountries=this.getPreOrPostCountry(excludedData.map(c=>c.value),cloneDeep(this.licensedForNonAdmitCountries));
                // }
            });

            // url.subscribe((res: any) => {
            //     console.warn(res.body != null ? res.body: res);
            // });

            if (this.insuranceCompany.id !== undefined) {
                this.countriesObj.push(this.insuranceCompany.companyAddressDTO.countryDTO);

                if (this.insuranceCompany.companyAddressDTO.countryDTO.isoTwo == 'US') {
                    this.isStateMandatory = true;
                    this.getStatesByCountryId(this.insuranceCompany.companyAddressDTO.countryDTO.id, false);
                } else {
                    this.isStateMandatory = false;
                    this.stateData = [];
                }

                this.telephoneCodeCountryObj.push(this.insuranceCompany.primaryContactCountryCode);

                this.surveyAssociationDataObj = [];
                this.insuranceCompany.surveyAssociationPriorityInfoDTO.map((item, index) => {
                    this.surveyAssociationDataObj[index] = new Array();
                    this.surveyAssociationPriorityObj[index] = new Array();
                    let obj = { id: item.priority, name: item.priority.toString() }
                    this.surveyAssociationDataObj[index].push(this.insuranceCompany.surveyAssociationPriorityInfoDTO[index].surveyAssociationDTO)
                    this.surveyAssociationPriorityObj[index].push(obj);
                })
                if (this.insuranceCompany.surveyAssociationPriorityInfoDTO.length == 0) {
                    this.insuranceCompany.surveyAssociationPriorityInfoDTO.push(new InsuranceCompanySurveyAssociationPriority());
                }

            } else {
                this.insuranceCompany.surveyAssociationPriorityInfoDTO.push(new InsuranceCompanySurveyAssociationPriority());
                this.allowAdd = true;
            }

            // @Ganesh
            if (this.insuranceCompany.fileDTO && this.insuranceCompany.fileDTO.fileId) {
                this.isRemoved = false;
            } else {
                this.isRemoved = true;
            }
        });





        this.insuranceCompanyService.getSurveyAssociations().subscribe((res: any) => {
            this.surveyAssociationData = res.body;
            this.surveyAssociationOriginalData = res.body;
            this.setData();
        });


        setTimeout(() => {
            this.getCounties();
        }, 1000);


        // this.openInformationModel();

    }

    getCounties() {
        let allCalls=[];
        allCalls.push(this.countryService.query());
        if(this.allStates==undefined||this.allStates.length==0) {
            allCalls.push(this.countryService.getByUrl("api/country/state/iso-two/" + "US"));
        }
        forkJoin(allCalls).subscribe(
            (res) => {
                
                this.countries=res[0].body;

                if((this.allStates==undefined||this.allStates.length==0) && allCalls.length==2) {
                    this.allStates = this.allStates.concat(res[1].body);
                }

                //usCountryId
                for (let index = 0; index < this.countries.length; index++) {
                    const element = this.countries[index];
                    if (element['isoTwo'] == 'US') {
                        this.usCountryId = element.id;
                        break;
                    }
                }
                // console.warn(this.usCountryId);

                //this.insuranceCompany.licensedNonAdmitCountries 

                // this.licensedCountriesAfterSelected(this.insuranceCompany.licensedNonAdmitCountries);
                // this.excludeCountriesAfterSelect(this.insuranceCompany.excludeCountries);
                
                // console.warn(this.selectedLicensedForNonAdmitCountries);
                // console.warn(this.selectedExcludedAdmittedCountries);
                // console.warn(this.insuranceCompany.licensedNonAdmitStates);
                // console.warn(this.insuranceCompany.excludeStates);
                this.licancedStateAfterSelect(this.insuranceCompany.licensedNonAdmitStates,this.selectedLicensedForNonAdmitCountries);
                this.excludeStateAfterSelect(this.insuranceCompany.excludeStates,this.selectedExcludedAdmittedCountries);

                //TODO to set state
            },
            (res: HttpErrorResponse) => this.onError(res.message)
        );
    }
    licensedCountriesAfterSelected(selectedLicancedCountries) {
        this.excludeCountries = [];

        if (selectedLicancedCountries == undefined) {
            this.excludeCountries = [...this.countries];
        } else {
            this.countries.forEach((obj) => {

                if (obj.isoTwo == 'US') {
                    console.log(obj);

                }
                if (obj.isoTwo == 'US') {
                    this.excludeCountries.push(obj);

                } else {
                    var existCOuntry = selectedLicancedCountries.find(({ id }) => obj.id === id);
                    if (!existCOuntry) {
                        this.excludeCountries.push(obj);
                    }
                }
            });
        }
        this.licancedStateAfterSelect(this.insuranceCompany.licensedNonAdmitStates,selectedLicancedCountries);
    }





    excludeCountriesAfterSelect(selectedExcludeCountries) {
        this.licensedCountries = [];
        if (selectedExcludeCountries == undefined) {
            this.licensedCountries = [...this.countries];
        } else {
            this.countries.forEach((obj) => {
                if (obj.isoTwo == 'US') {
                    this.licensedCountries.push(obj);
                } else {
                    var existCOuntry = selectedExcludeCountries.find(({ id }) => obj.id === id);
                    if (!existCOuntry) {
                        this.licensedCountries.push(obj);
                    }
                }

            });
        }
        // console.warn(selectedExcludeCountries);
        this.excludeStateAfterSelect(this.insuranceCompany.excludeStates,selectedExcludeCountries);
    }

    setData() {
        let tempArr = [];
        this.surveyAssociationOriginalData.map((item, index) => {
            let arr = { id: null, name: null };
            arr.id = index + 1;
            arr.name = (index + 1).toString();
            tempArr.push(arr);
            this.surveyAssociationOriginalPriorities = tempArr;
            this.surveyAssociationPriorities = tempArr
        })
        this.surveyAssociationOriginalPriorities = this.surveyAssociationOriginalPriorities.map(item => item);
        this.surveyAssociationPriorities = this.surveyAssociationPriorities.map(item => item);
    }

    // addParticipatingInsurer
    addParticipatingInsurer() {
        this.allowAdd = true;
        let participatingInsurer = new InsuranceCompanySurveyAssociationPriority();
        console.log(this.insuranceCompany.surveyAssociationPriorityInfoDTO.length);


        this.insuranceCompany.surveyAssociationPriorityInfoDTO.push(participatingInsurer);
        console.log(this.insuranceCompany.surveyAssociationPriorityInfoDTO.length);
    }

    // deleteParticipatingInsurer
    deleteParticipatingInsurer(index: number) {
        this.insuranceCompany.surveyAssociationPriorityInfoDTO.splice(index, 1);
        this.surveyAssociationDataObj.splice(index, 1);
        this.surveyAssociationPriorityObj.splice(index, 1);

        this.surveyAssociationPriorityObj.map((item, index) => {
            if (this.surveyAssociationPriorityObj[index] === []) {
                this.allowAdd = true;
            } else {
                this.allowAdd = false;
            }

        })
    }

    checkSurveyAssociationAllowToAdd() {
        let allowAdd = false;
            for (let index = 0; index < this.insuranceCompany.surveyAssociationPriorityInfoDTO.length; index++) {
                const element = this.insuranceCompany.surveyAssociationPriorityInfoDTO[index];
                if ((element.priority == undefined || element.priority == null) || (element.surveyAssociationDTO == undefined || element.surveyAssociationDTO == null) ) {
                    allowAdd = true
                }
                if (allowAdd) {
                    break;
                }
            }
        this.allowAdd = allowAdd;
        }

    onSurveyAssociationSelect(event, index, surveyAssociationDataObj, surveyAssociationPriorityObj) {
        // if ((surveyAssociationDataObj) && (surveyAssociationPriorityObj)) {
            //     this.allowAdd = false;
            // } else {
                //     this.allowAdd = true;
                // }
                
                this.insuranceCompany.surveyAssociationPriorityInfoDTO[index].surveyAssociationDTO = this.surveyAssociationDataObj[index][0];
                for (let i = 0; i < this.surveyAssociationDataObj.length; i++) {
                    if (index == i) {
                        for (let j = 0; j < this.surveyAssociationDataObj.length; j++) {
                            if (this.surveyAssociationDataObj[j] != null && this.surveyAssociationDataObj[j] != undefined) {                               
                                if ((this.surveyAssociationDataObj[j][0] && this.surveyAssociationDataObj[j][0].id == event.id) && index != j) {
                                    this.duplicateSurveyAssocianRemove(index);
                                    break;
                                }
                            }
                        }
                        break;
                    }
                    
                    // if ((this.surveyAssociationDataObj[i][0] && this.surveyAssociationDataObj[i][0].id == event.id)) {
                    //     this.duplicateSurveyAssocianRemove(index);
                    // }
                }
                this.checkSurveyAssociationAllowToAdd();
    }


    duplicateSurveyAssocianRemove(index:number) {
        this.insuranceCompany.surveyAssociationPriorityInfoDTO.splice(index, 1);
        this.surveyAssociationDataObj.splice(index, 1);
        this.surveyAssociationPriorityObj.splice(index, 1);
        this.checkSurveyAssociationAllowToAdd();
        this.onError('Survey Association Already Selected');
    }

    

    onSurveyAssociationDeSelect(event, index, surveyAssociationDataObj, surveyAssociationPriorityObj) {
        this.insuranceCompany.surveyAssociationPriorityInfoDTO[index].surveyAssociationDTO = null;
        this.allowAdd = true;
        surveyAssociationDataObj.splice(index, 1);
        surveyAssociationDataObj = [];
    }


    onPrioritySelect(event, index, surveyAssociationDataObj, surveyAssociationPriorityObj) {
        // if ((surveyAssociationDataObj) && (surveyAssociationPriorityObj)) {
            //     this.allowAdd = false;
            // } else {
                //     this.allowAdd = true;
                // }
                
                this.insuranceCompany.surveyAssociationPriorityInfoDTO[index].priority = event.id;
                for (let i = 0; i < this.surveyAssociationPriorityObj.length; i++) {
                    if (index == i) {
                        for (let j = 0; j < this.surveyAssociationPriorityObj.length; j++) {
                            if (this.surveyAssociationPriorityObj[j] != null && this.surveyAssociationPriorityObj[j] != undefined) {                            
                                if ((this.surveyAssociationPriorityObj[j][0] && this.surveyAssociationPriorityObj[j][0].id == event.id) && index != j) {
                                    this.removePrioritySelectObj(index);
                                    break;
                                }
                            }
                        }
                        break;
                    }
                    
                    // if ((this.surveyAssociationPriorityObj[i][0] && this.surveyAssociationPriorityObj[i][0].id == event.id)) {
                    //     this.removePrioritySelectObj(index);  
                    // }
                }
                this.checkSurveyAssociationAllowToAdd();

    }
    removePrioritySelectObj(index) {
        this.insuranceCompany.surveyAssociationPriorityInfoDTO.splice(index, 1);
        this.surveyAssociationDataObj.splice(index, 1);
        this.surveyAssociationPriorityObj.splice(index, 1);
        this.checkSurveyAssociationAllowToAdd();
        this.onError('Priority Already Selected');
    }

    onPriorityDeSelect(event, index, surveyAssociationDataObj, surveyAssociationPriorityObj) {
        this.insuranceCompany.surveyAssociationPriorityInfoDTO[index].priority = null;
        this.allowAdd = true;
        surveyAssociationPriorityObj.splice(index, 1);
        surveyAssociationPriorityObj= [];
    }

    trackBySurveyAssociation(index: number, item) {
        return index;
    }

    checkSurveyAssociationOnBlur(event, index, surveyAssociationDataObj, surveyAssociationPriorityObj) {
        console.log('asdasdasd');

    }


    previousState() {
        window.history.back();
    }

    save() {


        if (!this.isValidFile) {
            return;
        }

        let incDate = this.principal.dateFormateClientToServer(this.fromEffeciveDate.date);
        this.insuranceCompany.fromEffectiveDate = incDate;
        this.insuranceCompany.companyAddressDTO.countryDTO = this.countriesObj[0];
        if (this.stateObj && this.stateObj.length > 0) {
            this.insuranceCompany.companyAddressDTO.state = this.stateObj[0];
        } else {
            this.insuranceCompany.companyAddressDTO.state = null;
        }

        this.openConfirmationModalForFutureRecordDeletion();
        // this.openInformationModel();
    }

    saveOrUpdate() {


        if (this.flag) {
            this.uploadFile(this.fileMultiPartData);
        } else if (this.insuranceCompany.fileDTO && this.insuranceCompany.fileDTO.fileId && this.isRemoved) {
            let fileId = this.insuranceCompany.fileDTO.fileId;
            let cdate = this.principal.dateFormateClientToServerCDate();
            if (this.insuranceCompany.fromEffectiveDate === cdate) {
                this.clauseExtensionService.deleteFileService(fileId).subscribe(
                    response => {
                        this.isRemoved = true;
                    },
                    err => {
                        console.log(err);
                    }
                );
            } else {
                this.isRemoved = true;
            }
            this.saveInsuranceCompany();
        } else {
            this.saveInsuranceCompany();
        }
    }

    saveInsuranceCompany() {
        // console.warn(this.selectedLicensedForNonAdmitCountries);
        if(this.selectedLicensedForNonAdmitCountries && this.selectedLicensedForNonAdmitCountries.length > 0) {
            
            this.insuranceCompany.licensedNonAdmitCountries = [];
            this.selectedLicensedForNonAdmitCountries.filter(c => this.licensedForNonAdmitCountriesMap.has(c)).forEach(c => {
                const country: TreeviewItem = this.licensedForNonAdmitCountriesMap.get(c);
                this.insuranceCompany.licensedNonAdmitCountries.push({id: country.value, name: country.text});
            });
            // console.warn(this.insuranceCompany.licensedNonAdmitCountries);
        } else {
            // 
            this.insuranceCompany.licensedNonAdmitCountries = [];
            // console.warn(this.insuranceCompany.licensedNonAdmitCountries);
        }

        // console.warn(this.selectedExcludedAdmittedCountries);
        if(this.selectedExcludedAdmittedCountries && this.selectedExcludedAdmittedCountries.length > 0) {
            // 
            this.insuranceCompany.excludeCountries = [];
            this.selectedExcludedAdmittedCountries.filter(c => this.excludeAdmitCountriesMap.has(c)).forEach(c => {
                const country: TreeviewItem = this.excludeAdmitCountriesMap.get(c);
                this.insuranceCompany.excludeCountries.push({id: country.value, name: country.text});
            });
            // console.warn(this.insuranceCompany.excludeCountries);
        } else {
            // 
            this.insuranceCompany.excludeCountries = [];
            // console.warn(this.insuranceCompany.excludeCountries);
        }


        if (this.insuranceCompany.surveyAssociationPriorityInfoDTO.length > 1) { 
            for (let i = 0; i<this.insuranceCompany.surveyAssociationPriorityInfoDTO.length ;i++ ){
                let res = this.insuranceCompany.surveyAssociationPriorityInfoDTO[i]
                if (res.priority == null || res.priority == undefined || res.surveyAssociationDTO == null || res.surveyAssociationDTO == undefined) {
                    this.jhiAlertService.error(' Please provide all data for Survey Associations')
                    return;
                }
            };
        } else {
            for (let i = 0; i < 1; i++) {
                let res = this.insuranceCompany.surveyAssociationPriorityInfoDTO[i]
                if ((this.checkNullOfUndefined(res.priority) && !this.checkNullOfUndefined(res.surveyAssociationDTO)) || (!this.checkNullOfUndefined(res.priority) && this.checkNullOfUndefined(res.surveyAssociationDTO))) {
                    this.jhiAlertService.error(' Please provide all data for Survey Associations')
                    return;
                }
            };
        }
        
        if (!this.isLicencedStateMandatory) {
            this.insuranceCompany.licensedNonAdmitStates = [];
        }
        // console.warn(this.isExcludedStateMandatory);
        if (!this.isExcludedStateMandatory) {
            this.insuranceCompany.excludeStates = [];
        }
        this.isSaving = true;
        if (this.insuranceCompany.fileDTO && this.insuranceCompany.fileDTO.fileId && this.isRemoved) {
            this.insuranceCompany.fileDTO.fileId = null;
            this.insuranceCompany.fileDTO.name = null;
        }

        if (this.insuranceCompany.id !== undefined) {
            this.subscribeToSaveResponse(this.insuranceCompanyService.update(this.insuranceCompany));
        } else {
            this.subscribeToSaveResponse(this.insuranceCompanyService.create(this.insuranceCompany));
        }
        // }
    }

    private subscribeToSaveResponse(result: Observable<HttpResponse<IInsuranceCompanyMySuffix>>) {
        result.subscribe(
            (res: HttpResponse<IInsuranceCompanyMySuffix>) => this.onSaveSuccess(),
            (res: HttpErrorResponse) => this.onSaveError()
        );
    }

    private onSaveSuccess() {
        this.isSaving = false;
        this.deleteExistedFutureRecordDetails();
        this.previousState();
    }

    private onSaveError() {
        this.isSaving = false;
    }

    private onError(errorMessage: string) {
        this.jhiAlertService.error(errorMessage, null, null);
    }

    trackFileDataById(index: number, item: IFileDataMySuffix) {
        return item.id;
    }

    trackAddressById(index: number, item: IAddressMySuffix) {
        return item.id;
    }

    trackCountryById(index: number, item: ICountryMySuffix) {
        return item.id;
    }
    onCountryItemSelect(event) {
        this.stateData = [];
        this.stateObj = [];
        this.insuranceCompany.companyAddressDTO.addressCountryId = event.id;
        this.getStatesByCountryId(event.id, true);
    }
    getSelected(selectedVals: Array<any>, option: any) {
        if (selectedVals) {
            for (let i = 0; i < selectedVals.length; i++) {
                if (option.id === selectedVals[i].id) {
                    return selectedVals[i];
                }
            }
        }
        return option;
    }
    get insuranceCompany() {
        return this._insuranceCompany;
    }

    set insuranceCompany(insuranceCompany: IInsuranceCompanyMySuffix) {
        this._insuranceCompany = insuranceCompany;

        this.stateObj = [];

        if (this.insuranceCompany && this.insuranceCompany.companyAddressDTO && this.insuranceCompany.companyAddressDTO.state && this.insuranceCompany.companyAddressDTO.state.id) {
            this.stateObj.push(this.insuranceCompany.companyAddressDTO.state);
        }
    }

    // init call

    uploadFileInitialMethod($event) {


        this.fileMultiPartData = $event.target.files[0];
        if (this.fileMultiPartData) {
            let exten: string = this.fileMultiPartData.type;
            this.flag = true;
            this.isRemoved = false;
            if (exten.includes('image/') && (exten !== 'image/gif')) {
                this.isValidFile = true;
            } else {
                this.isValidFile = false;
                return;
            }
        } else {
            this.flag = false;
            if (this.insuranceCompany.fileDTO && !this.insuranceCompany.fileDTO.fileId) {
                this.isRemoved = true;
            }
        }
    }

    // file upload method
    uploadFile(data) {
        let formData = new FormData();
        formData.append('file', data);
        this.clauseExtensionService.uploadFileService(formData).subscribe(response => {
            if (response.body.fileId) {
                console.log(response);


                if (this._insuranceCompany.fileDTO == null) {
                    this._insuranceCompany.fileDTO = new FileDataMySuffix();
                }
                this._insuranceCompany.fileDTO.fileId = response.body.fileId;
                this._insuranceCompany.fileDTO.name = response.body.name;
                this._insuranceCompany.fileDTO.contenttype = response.body.contentType;
                this._insuranceCompany.fileDTO.sizeInBytes = response.body.size;
                // after getting the fileId from mongoDB invoking the saveClauseExtension
                this.flag = false;
                this.saveOrUpdate();
            }
        });
    }

    numberOnly(event) {
        const charCode = event.which ? event.which : event.keyCode;
        if (charCode == 46) {
            return true;
        } else if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        } else return true;
    }

    onItemSelect(event, index) {
        $(document)
            .find('#laguagesKnownid0')
            .find('.dropdown-list')
            .addClass('showDropdown');

        console.log('event', event);
        this.licensedCountriesAfterSelected(this.insuranceCompany.licensedNonAdmitCountries)
    }

    onDropdownClose0(event, index) {
        $(document)
            .find('#laguagesKnownid0')
            .find('.dropdown-list')
            .removeClass('showDropdown');
    }
    onDropdownClose1(event, index) {
        $(document)
            .find('#laguagesKnownid1')
            .find('.dropdown-list')
            .removeClass('showDropdown');
    }

    onItemDeSelect(event, index) {
        $(document)
            .find('#laguagesKnownid0')
            .find('.dropdown-list')
            .addClass('showDropdown');
            if (event.id == this.usCountryId) {
                this.insuranceCompany.licensedNonAdmitStates = [];
            }
        this.licensedCountriesAfterSelected(this.insuranceCompany.licensedNonAdmitCountries);


    }
    onSelectAll(event) {
       
        this.licensedCountriesAfterSelected(event);
    }

    onDeSelectAll(event) {
        this.insuranceCompany.licensedNonAdmitStates = [];
        this.licensedCountriesAfterSelected(event);
    }
    onItemSelectExclude(event, index) {
        $(document)
            .find('#laguagesKnownid1')
            .find('.dropdown-list')
            .addClass('showDropdown');
        this.excludeCountriesAfterSelect(this.insuranceCompany.excludeCountries);
    }

    onItemDeSelectExclude(event) {
        $(document)
            .find('#laguagesKnownid1')
            .find('.dropdown-list')
            .removeClass('showDropdown');
        if (event.id == this.usCountryId) {
            this.insuranceCompany.excludeStates = [];
        }
        this.excludeCountriesAfterSelect(this.insuranceCompany.excludeCountries);
    }

    onItemDeSelectAllExclude(event) {
        $(document)
            .find('#laguagesKnownid1')
            .find('.dropdown-list')
            .addClass('showDropdown');
        this.insuranceCompany.excludeStates = [];
        this.excludeCountriesAfterSelect(event);
    }

    onItemSelectAllExclude(event) {
        this.excludeCountriesAfterSelect(event);
    }

    onCountrySelect(event) {

        for (let i = 0; i < this.countries.length; i++) {
            if (this.countries[i].id == event.id) {
                this.insuranceCompany.primaryContactCountryCode = event;
                this.insuranceCompany.primaryContactCountryCode.code = event.code;
                this.insuranceCompany.pContactCountryCode = this.countries[i].code;
                break;
            }
        }
    }
    onCountryDeSelect(event) {
        this.insuranceCompany.primaryContactCountryCode = null;
        this.insuranceCompany.pContactCountryCode = null;
    }

    onCountryItemDeSelect(event) {
        this.stateData = [];
        this.stateObj = [];
    }

    //  This method will remove file from mongoDB and yet to remove from PostgresSQL

    isRemoved: boolean;
    removeSignature() {
        this.isRemoved = true;
        this.isValidFile = true;
    }

    trimName(event) {
        if (this.insuranceCompany.name) {
            this.insuranceCompany.name = this.insuranceCompany.name.trim();
        }
    }
    trim(event) {
        if (event.target.value) {
            event.target.value = event.target.value.replace(/\s\s+/g, ' ').trim();
        }
    }
    trimStreetAddress(event) {
        if (this.insuranceCompany.companyAddressDTO.streetAddress) {
            this.insuranceCompany.companyAddressDTO.streetAddress = this.insuranceCompany.companyAddressDTO.streetAddress.trim();
        }
    }

    trimCity(event) {
        if (this.insuranceCompany.companyAddressDTO.city) {
            this.insuranceCompany.companyAddressDTO.city = this.insuranceCompany.companyAddressDTO.city.trim();
        }
    }

    trimState($event) {
        if (this.insuranceCompany.companyAddressDTO.state) {
            this.insuranceCompany.companyAddressDTO.state.name = this.insuranceCompany.companyAddressDTO.state.name;
        }
    }

    trimPostalCode($event) {
        if (this.insuranceCompany.companyAddressDTO.postalCode) {
            this.insuranceCompany.companyAddressDTO.postalCode = this.insuranceCompany.companyAddressDTO.postalCode.trim();
        }
    }

    onDateChanged(event: IMyDateModel) {
        if (this.insuranceCompany.id !== null && this.insuranceCompany.id !== undefined) {
            let selectedFromEffectiveDate = this.principal.dateFormateClientToServer(event.date)
            // console.log('onDateChanged(): ', selectedFromEffectiveDate);
            this.insuranceCompanyService.findByIdAndFromEffectiveDate(this.insuranceCompany.id, selectedFromEffectiveDate).subscribe(response => {
                console.log(response);
                if (response.body != null && response.body['isSuccess']) {
                    this.insuranceCompany = response.body['payLoad'];
                    if (this.insuranceCompany.id !== undefined) {
                        this.countriesObj = [];
                        this.telephoneCodeCountryObj = [];
                        this.countriesObj.push(this.insuranceCompany.companyAddressDTO.countryDTO);

                        this.countryService.find(this.insuranceCompany.companyAddressDTO.countryDTO.id).subscribe(res => {
                            let body = res.body;
                            if (body['isoTwo'] == 'US') {
                                this.isStateMandatory = true;
                                if (this.insuranceCompany.companyAddressDTO.state && this.insuranceCompany.companyAddressDTO.state.id) {
                                    this.stateObj.push(this.insuranceCompany.companyAddressDTO.state);
                                }
                                this.getStatesByCountryId(this.insuranceCompany.companyAddressDTO.countryDTO.id, false);
                            } else {
                                this.isStateMandatory = false;
                                this.stateData = [];
                            }

                        }, err => { });




                        this.telephoneCodeCountryObj.push(this.insuranceCompany.primaryContactCountryCode);

                        this.surveyAssociationDataObj = [];
                        this.surveyAssociationPriorityObj = [];
                        this.insuranceCompany.surveyAssociationPriorityInfoDTO.map((item, index) => {
                            this.surveyAssociationDataObj[index] = new Array();
                            this.surveyAssociationPriorityObj[index] = new Array();
                            let obj = { id: item.priority, name: item.priority.toString() }
                            this.surveyAssociationDataObj[index].push(this.insuranceCompany.surveyAssociationPriorityInfoDTO[index].surveyAssociationDTO)
                            this.surveyAssociationPriorityObj[index].push(obj);
                        })
                        if (this.insuranceCompany.surveyAssociationPriorityInfoDTO.length == 0) {
                            this.insuranceCompany.surveyAssociationPriorityInfoDTO = [];
                            this.insuranceCompany.surveyAssociationPriorityInfoDTO.push(new InsuranceCompanySurveyAssociationPriority());
                        }

                        this.fileMultiPartData = this.insuranceCompany.fileDTO;
                        this.checkSurveyAssociationAllowToAdd();

                    } else {
                        this.insuranceCompany.surveyAssociationPriorityInfoDTO = [];
                        this.insuranceCompany.surveyAssociationPriorityInfoDTO.push(new InsuranceCompanySurveyAssociationPriority());
                        this.allowAdd = true;
                    }

                    this.getCounties();

                    if (this.insuranceCompany.fileDTO.fileId) {
                        this.isRemoved = false;
                    } else {
                        this.isRemoved = true;
                    }
                }
            });
        }
    }


    
    
    // global modal open and close event
    bsModalRef: BsModalRef;

    isConfirmDeletion = false;
    /* this is how we open a Modal Component from another component */
    openConfirmationModalForFutureRecordDeletion() {
        this.isConfirmDeletion = false;
        if (this.insuranceCompany.id !== null && this.insuranceCompany.id !== undefined) {
            let form_data = {
                masterId: this.insuranceCompany.id,
                futureDataType: FutureDataType.INSURANCE_COMPANY.valueOf(),
                fromEffectiveDateFormatted: this.insuranceCompany.fromEffectiveDate
            }
            this.confirmationModelService.findFutureRecordExisted(form_data).subscribe(response => {
                const resBody = response.body;
                if (resBody.isSuccess) {
                    const initialState = {
                        title: 'Insurance Company (' + this.insuranceCompany.name + ')',
                        message: resBody.message,
                    };
                    this.bsModalRef = this.modalService.show(ConfirmationModalComponent, { initialState, class: "modal-lg" });
                    this.bsModalRef.content.onClose.subscribe(result => {
                        if (result) {
                            this.isConfirmDeletion = true;
                            this.saveOrUpdate();
                        }
                    });
                } else {
                    this.saveOrUpdate();
                }
            });

        } else {
            this.saveOrUpdate();
        }
    }


    deleteExistedFutureRecordDetails() {
        if (this.isConfirmDeletion) {
            let form_data = {
                masterId: this.insuranceCompany.id,
                futureDataType: FutureDataType.INSURANCE_COMPANY.valueOf(),
                fromEffectiveDateFormatted: this.insuranceCompany.fromEffectiveDate
            }
            this.confirmationModelService.deleteExistedFutureRecord(form_data).subscribe(response => {
                console.log(response);
                this.isConfirmDeletion = false;
            });
        }
    }

    openInformationModel() {

        if (this.insuranceCompany.id !== null && this.insuranceCompany.id !== undefined) {
            let form_data = {
                masterId: this.insuranceCompany.id,
                informationType: InformationType.INSURANCE_COMPANY.valueOf()
            }
            this.informationModelService.fetchExistedInformationDetailsByType(form_data).subscribe(response => {
                const resBody = response.body;
                if (resBody && resBody.length > 0) {
                    const initialState = {
                        isUpdateType: true,
                        mainList: resBody,
                    };
                    this.bsModalRef = this.modalService.show(InformationModelComponent, { initialState, class: "modal-lg" });
                    this.bsModalRef.content.onClose.subscribe(result => {
                        console.log(result);
                        if (result) {
                            this.openConfirmationModalForFutureRecordDeletion();
                        }
                    });
                } else {
                    this.openConfirmationModalForFutureRecordDeletion();
                }
            });
        }

    }
    trimField(event) {
        if (event.target.value) {
            event.target.value = event.target.value.trim()
        }
    }
    // method for allow alphabets and space and DOT symbol
    customContactNameRegularExpression(event) {
        const charCode = event.which ? event.which : event.keyCode;
        let value = event.target.value;
        let findLengthOfDotSymbol = 0;
        if (value.length > 0) {
            let array = value.split('');
            findLengthOfDotSymbol = array.filter(l => l === '.').length;
            console.log(findLengthOfDotSymbol, "findLengthOfDotSymbol");
        } else if (charCode == 32 && value.length == 0) {
            return false
        }
        // for allow only one dot 
        if (charCode == 46 && findLengthOfDotSymbol > 0) {
            return false
        }

        if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123) || charCode == 8 || charCode == 32 || charCode == 46) {
            return true;
        }
        else {
            return false;
        }
    }
    // if the form invalid open survey association Panel
    saveClick(formValid) {
        if (formValid) {

        } else {
            this.isInsurersCollapsed = false;
        }
    }
    stateMandatory(id) {
        let flag = false;
        this.countries.map(date => {

            if (date['isoTwo'] == 'US' && date.id == id) {
                flag = true;
                return;
            }
        });
        this.isStateMandatory = flag;
    }
    getStatesByCountryId(id, flag: boolean) {

        this.countryService.getStatesByCountryId(id).subscribe(res => {
            this.stateData = res.body;
        });


        if (flag) {
            this.stateMandatory(id);
        }

    }
    async statesByCountryIsoTwo(iso: String) {
        this.countryService.getByUrl("api/country/state/iso-two/" + iso).subscribe(res => {
            this.allStates = this.allStates.concat(res.body);
        });
    }



    // licancedStateAfterSelect(selectedLicancedStates,licensedNonAdmitCountries) {
    //     //this.insuranceCompany.licensedNonAdmitCountries
    //     if (licensedNonAdmitCountries && licensedNonAdmitCountries.length > 0) {
    //         this.excludeStates = [];
    //         var existCountry = licensedNonAdmitCountries.find(({ id }) => this.usCountryId === id);
    //         this.isLicencedStateMandatory = existCountry ? true : false;
    //         if (this.isLicencedStateMandatory) {
    //             if (selectedLicancedStates == undefined) {
    //                 this.excludeStates = [...this.allStates];
    //             } else {
    //                 this.allStates.forEach((obj) => {
    //                     var state = selectedLicancedStates.find(({ id }) => obj.id === id);
    //                     if (!state) {
    //                         this.excludeStates.push(obj);
    //                     }
    //                 });
    //             }
    //         } else {
    //             this.insuranceCompany.licensedNonAdmitStates = [];
    //             this.excludeStates = [...this.allStates];
    //             this.isLicencedStateMandatory = false;
    //         }
    //     } else {
    //         this.excludeStates = [...this.allStates];
    //         this.isLicencedStateMandatory = false;
    //     }

    //     if ((!this.insuranceCompany.excludeCountries)) {
    //         this.licensedStates = [...this.allStates];
    //     }

    // }

    licancedStateAfterSelect(selectedLicancedStates,licensedNonAdmitCountries) {

        if (licensedNonAdmitCountries && licensedNonAdmitCountries.length > 0) {
            this.excludeStates = [];
            var existCountry = licensedNonAdmitCountries.find((c) => this.usCountryId === c);
            this.isLicencedStateMandatory = existCountry ? true : false;
            // console.warn(existCountry);
            if (this.isLicencedStateMandatory) {
                if (selectedLicancedStates == undefined) {
                    this.excludeStates = [...this.allStates];
                    
                    // console.warn(this.excludeStates);
                } else {
                    
                    this.allStates.forEach((obj) => {
                        var state = selectedLicancedStates.find(({ id }) => obj.id === id);
                        if (!state) {
                            this.excludeStates.push(obj);
                        }
                    });
                    // console.warn(this.excludeStates);
                    // console.warn(this.excludeStates);
                }
            } else {
                this.insuranceCompany.licensedNonAdmitStates = [];
                this.excludeStates = [...this.allStates];
                
                this.isLicencedStateMandatory = false;
                // console.warn(this.excludeStates);
            }
        } else {
            this.excludeStates = [...this.allStates];
            
            // this.isLicencedStateMandatory = false;
            
            // console.warn(this.excludeStates);
        }

        // if ((!this.insuranceCompany.excludeCountries)) {
        //     this.licensedStates = [...this.allStates];
        // }

        if ((!this.selectedExcludedAdmittedCountries)) {
            this.licensedStates = [...this.allStates];
        }
        // console.warn(this.isLicencedStateMandatory, ' => isLicencedStateMandatory');
        // console.warn(this.excludeStates);

    }

    excludeStateAfterSelect(selectedExcludedStates,excludeCountries) {
        // this.insuranceCompany.excludeCountries 
        // console.warn(excludeCountries && excludeCountries.length > 0);
        // console.warn(excludeCountries);
        // console.warn(excludeCountries.length);
        if (excludeCountries && excludeCountries.length > 0) {
            
            // console.warn(this.excludeStates);
            this.licensedStates = [];
            // console.warn(this.isExcludedStateMandatory);
            var existCountry = excludeCountries.find(( c ) => this.usCountryId === c);
            this.isExcludedStateMandatory = existCountry ? true : false;
            // console.warn(this.isExcludedStateMandatory);
            if (this.isExcludedStateMandatory) {
                if (selectedExcludedStates == undefined) {
                    this.licensedStates = [...this.allStates];
                    
                    // console.warn(this.excludeStates);
                } else {
                    this.allStates.forEach((obj) => {
                        var state = selectedExcludedStates.find(({ id }) => obj.id === id);
                        if (!state) {
                            this.licensedStates.push(obj);
                        }
                    });
                    
                    // console.warn(this.excludeStates);
                }
            } else {
                this.insuranceCompany.excludeStates = [];
                this.licensedStates = [...this.allStates];
                this.isExcludedStateMandatory = false;
                
                // console.warn(this.excludeStates);
                // console.warn(this.isExcludedStateMandatory);
            }
        } else {
            // console.warn(this.isExcludedStateMandatory);
            this.licensedStates = [...this.allStates];
            // this.isExcludedStateMandatory = false;
            
            // console.warn(this.excludeStates);
            // console.warn(this.isExcludedStateMandatory);
        }
        // console.warn(this.insuranceCompany.licensedNonAdmitCountries);
        // if ((!this.insuranceCompany.licensedNonAdmitCountries)) {
        //     this.excludeStates = [...this.allStates];
        //     console.warn(this.excludeStates);
        // }

        if ((!this.selectedLicensedForNonAdmitCountries)) {
            this.excludeStates = [...this.allStates];
            // console.warn(this.excludeStates);
        }

    }

    //states methods

    //licanced
    onLicancedStateSelect(event) {
        this.licancedStateAfterSelect(this.insuranceCompany.licensedNonAdmitStates,this.selectedLicensedForNonAdmitCountries);

    }
    onLicancedStateDeSelect(event) {
        this.licancedStateAfterSelect(this.insuranceCompany.licensedNonAdmitStates,this.selectedLicensedForNonAdmitCountries);
    }

    onLicancedStateSelectAll(event) {
        this.licancedStateAfterSelect(event,this.selectedLicensedForNonAdmitCountries);
    }
    onLicancedStateDeSelectAll(event) {
        this.licancedStateAfterSelect(event,this.selectedLicensedForNonAdmitCountries);
    }

    //exclude
    onExcludeStateSelect(event) {
        this.excludeStateAfterSelect(this.insuranceCompany.excludeStates,this.selectedExcludedAdmittedCountries );
    }
    onExcludeStateDeSelect(event) {
        this.excludeStateAfterSelect(this.insuranceCompany.excludeStates,this.selectedExcludedAdmittedCountries );
    }
    onExcludeStateSelectAll(event) {
        this.excludeStateAfterSelect(event,this.selectedExcludedAdmittedCountries );
    }

    onExcludeStateDeSelectAll(event) {
        this.excludeStateAfterSelect(event,this.selectedExcludedAdmittedCountries);
    }

    ngOnDestroy(): void {
       this.jhiAlertService.clear()
    }


    checkNullOfUndefined(data) {
        return data==null || data ==undefined
    }

    licensedNonAdmitDropdownCalled=false;
    excludedAdmitDropdownCalled=false;
    isLicensedStateAfterSelectCalledOnce: boolean = false;

    // this method is called on licensed treeview and is used for binding, check/uncheck and preserve the check/uncheck for both the continents and for removing and showing the data
    selectedLicensedNonAdmitCountries(event){
        // if(event.length==0) return;
   
        // this.licensedNonAdmitDropdownCalled=true;
        if(this.licensedNonAdmitDropdownCalled){

            this.selectedLicensedForNonAdmitCountries = event;
            this.nonAdmitCountriesId=event;

            // console.warn(this.selectedLicensedForNonAdmitCountries);
            // console.warn(this.isInitDropdownMethodCalled);
            this.isInitDropdownMethodCalled=true;
            

            if(this.isInitDropdownMethodCalled) { // to prevent on page load data corruption
                // console.warn(this.selectedLicensedForNonAdmitCountries);
                this.excludeAdmittedCountries=this.getPreOrPostCountry(this.selectedLicensedForNonAdmitCountries,this.allCountryTreeViewData);

                if(this.selectedExcludedAdmittedCountries.length>0){
                    this.excludeAdmittedCountries=this.preserveCheckForCountries(this.selectedExcludedAdmittedCountries,this.excludeAdmittedCountries);
                    // console.warn(this.excludeAdmittedCountries);
                }

                const isUSCountrySelected = event.includes(this.usCountryId);
                if(!isUSCountrySelected) {
                    
                    this.isLicencedStateMandatory = false;

                    if(!isUSCountrySelected && !this.isLicencedStateMandatory) {
                        this.licancedStateAfterSelect(this.insuranceCompany.licensedNonAdmitStates,this.selectedLicensedForNonAdmitCountries);
                    }

                    this.insuranceCompany.licensedNonAdmitStates = [];
                    // this.licancedStateAfterSelect(this.insuranceCompany.licensedNonAdmitStates, event);
                } else{
                    this.isLicencedStateMandatory = true;
                }
            }
            // if(this.excludeAdmittedCountries.length==0) {
                //     console.warn(this.selectedLicensedForNonAdmitCountries);
                //     // this.excludeAdmittedCountries=cloneDeep(this.allCountryTreeViewData);
                // }
            // console.warn(this.excludeAdmittedCountries);
        }
        
    }

    // this method is called on licensed treeview and is used for binding, check/uncheck and preserve the check/uncheck for both the continents and for removing and showing the data
    selectedExcludedNonAdmitCountries(event){
        // console.warn(event.length);
        // if(event.length==0) return;
        // console.warn(this.excludedAdmitDropdownCalled);
        if(this.excludedAdmitDropdownCalled){
            this.selectedExcludedAdmittedCountries = event;
            this.excludeAdmitCountriesId = event;
            
            this.isInitDropdownMethodCalledExlcudedCountries=true;
            if(this.isInitDropdownMethodCalledExlcudedCountries) { // to prevent on page load data curruption
                this.licensedForNonAdmitCountries=this.getPreOrPostCountry(this.selectedExcludedAdmittedCountries,this.allCountryTreeViewData);
                //     // this.licensedForNonAdmitCountries=this.getPreOrPostCountry(this.selectedExcludedAdmittedCountries,cloneDeep(this.allCountryTreeViewData));
                if(this.selectedLicensedForNonAdmitCountries.length>0){
                    this.licensedForNonAdmitCountries=this.preserveCheckForCountries(this.selectedLicensedForNonAdmitCountries,this.licensedForNonAdmitCountries);
                }

                const isUSCountrySelected = event.includes(this.usCountryId);
                if(!isUSCountrySelected) {
                    // console.warn(this.isExcludedStateMandatory);
                    
                    this.isExcludedStateMandatory = false;
                    // console.warn(this.insuranceCompany.excludeStates);
                    if(!isUSCountrySelected && !this.isExcludedStateMandatory) {
                        this.excludeStateAfterSelect(this.insuranceCompany.excludeStates, this.selectedExcludedAdmittedCountries);
                    }
                    this.insuranceCompany.excludeStates = [];
                    // console.warn(!isUSCountrySelected && !this.isExcludedStateMandatory);
                    // this.licancedStateAfterSelect(this.insuranceCompany.licensedNonAdmitStates, event);
                }else{
                    this.isExcludedStateMandatory = true;
                }
                // console.warn(this.isExcludedStateMandatory); 
            }
            
            

            if(this.licensedForNonAdmitCountries.length==0) {
                // this.licensedForNonAdmitCountries=cloneDeep(this.allCountryTreeViewData);
            }
        }
        // console.warn(this.licensedForNonAdmitCountries);
    }

    /**
    * This method is used to convert the countries into TreeviewItem and based on the key, storing it in the map
    * @param data - countries 
    * @param typeOfCountry - licensedNonAdmitCountries or excludedCountries
    * @returns countries in TreeviewItem format
    */
    mapToTreeViewItem(data, typeOfCountry){
        for(let i = 0;i<data.length;i++){
            data[i] = new TreeviewItem(data[i],true); // continent
            if(data[i].children && data[i].children.length>0){
                for(let j = 0;j<data[i].children.length;j++){
                    data[i].children[j]= new TreeviewItem(data[i].children[j],true); // region
                    if(data[i].children[j] && data[i].children[j].children.length>0){
                        for(let k = 0;k<data[i].children[j].children.length;k++){
                            data[i].children[j].children[k]= new TreeviewItem(data[i].children[j].children[k]); // country
                            if(typeOfCountry === 'licensedNonAdmitCountries') {
                                this.licensedForNonAdmitCountriesMap.set(data[i].children[j].children[k].value,data[i].children[j].children[k]);
                            } else if(typeOfCountry === 'excludedCountries') {
                                this.excludeAdmitCountriesMap.set(data[i].children[j].children[k].value,data[i].children[j].children[k]);
                            }
                            if(data[i].children[j].children[k]["text"]=="United States"){
                                this.usCountryId = data[i].children[j].children[k].value;
                            }
                        }
                    }
                }
            }
        }
        // console.warn(this.countriesMap);
        // console.warn(data);
        return data;
    }


    /**
    * @param ids - selected countries ids
    * @param allData - default all countries Data in TreeviewItem form
    * @returns data - on checked/unchecked, removing countries from the excluded/licensed countries dropdown
    */
    getPreOrPostCountry(ids: any[],allData:any[]) {
        // console.warn(ids);
        let data: any = [];
        let continentMap = new Map<number,any>();
        let regionMap = new Map<number,any>();
        // this.countryData=[];

        ids = ids.filter(i=>i!=this.usCountryId)

        let treMapCountries:TreeviewItem[] = cloneDeep(allData);
        // console.log(treMapCountries);

            for(let i = 0; i < treMapCountries.length; i++) {
                    for(let j = 0; j < treMapCountries[i].children.length; j++) { // region
                            for(let k = 0; k < treMapCountries[i].children[j].children.length; k++) { // country
                                let d = treMapCountries[i].children[j].children[k];
                                /**
                                 * check if ids array contains d.value or not.
                                 * if it doesn't contains, convert the country (not regions and continents) in TreeviewItem
                                 */
                                if(ids && !ids.includes(d.value)) {
                                    let cont = new TreeviewItem(treMapCountries[i].children[j].children[k]);
                                    // this.countriesMap.set(cont.value,cont);

                                    let con;
                                    let reg;
                                    let isRegionExisted = true; // by default region exists
                                    let isContinentExisted = true; // by default continent exists
                                    /**
                                     * check in region, if value exists or not,
                                     * if it doesnt exists, convert countries under regions into TreeviewItem, and make isRegionExisted false,
                                     * else get the value and push it into the region children
                                     * doing the same for continent and checking if region exists or not
                                     */
                                    if(!regionMap.has(treMapCountries[i].children[j].value)){
                                        reg = new TreeviewItem(treMapCountries[i].children[j]);
                                        reg.children=[cont];
                                        regionMap.set(reg.value,reg);
                                        isRegionExisted=false;
                                    }else{
                                        reg = regionMap.get(treMapCountries[i].children[j].value);
                                        reg.children.push(cont);
                                    }
                                    
                                    if(!continentMap.has(treMapCountries[i].value)){
                                        con = new TreeviewItem(treMapCountries[i]);
                                        con.children=[reg];
                                        continentMap.set(con.value,con);
                                        isContinentExisted=false;
                                   }else{
                                       con = continentMap.get(treMapCountries[i].value);
                                       if(!isRegionExisted){
                                           con.children.push(reg);
                                       }
                                   }
                                   
                                    
                                    // console.log(con);
                                    if(!isContinentExisted){
                                        data.push(con);
                                    }
                                }else{
                                    // console.log(d);
                                }
                            }
                        }
                    }
                
                    // console.log(this.countryData);


        //    });

        // console.warn(data);
        return cloneDeep(data);
    }


    ngAfterViewInit(): void {}
    
    // this method is used to control the calling of the methods in treeview dropdown, as there is change detection in dropdown
    licensedCountriesClick(event){
        this.licensedNonAdmitDropdownCalled= true;
        this.excludedAdmitDropdownCalled = false;
    }
    
    // this method is used to control the calling of the methods in treeview dropdown, as there is change detection in dropdown
    excludedCountriesClick(event){
        this.licensedNonAdmitDropdownCalled= false;
        this.excludedAdmitDropdownCalled = true;
    }

    /**
    * This method is used to return the preserved checked countries from licensed or excluded countries dropdown
    * @param countriesId  - selected countries id only as an array
    * @param data - licensedCountryData or excludedCountryData
    * @returns checked excluded or licensed countries
    */
    preserveCheckForCountries(countriesId: any, data: TreeviewItem[]) {
        // console.warn(countriesId);
        for(let i = 0; i < data.length; i++) {
            for(let j = 0; j < data[i].children.length; j++) {
                for(let k = 0; k < data[i].children[j].children.length; k++) {
                    let d = data[i].children[j].children[k];
                    // mark the country as checked, if countriesIds has country.value(d)
                    d.checked = countriesId.includes(d.value);
                }
                // if all countries are selected, mark the region as checked
                data[i].children[j].checked = data[i].children[j].children.every(c=>c.checked==true)
            }
            // if all the regions are checked, mark the continent as checked
            data[i].checked = data[i].children.every(c=>c.checked==true)
        }
        return data;
    }

}